export default __webpack_public_path__ + "static/media/remove-icon.6f01e70e.svg";